import { useNuxtApp } from '#imports'

import type { I18n } from '../types/i18n'

export function useI18n(): I18n {
  return useNuxtApp().$i18n as I18n
}
